import { useNavigate } from "react-router-dom";
import { NavCardProps } from "../types/prop.navcard";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducer/rootReducer";

export const useMenuItems = (): Array<NavCardProps> => {
  const navigate = useNavigate();
  const user = useSelector((state: RootState) => state.user);
  const MenuItems: Array<NavCardProps> = [
    {
      title: "Quality Planning",
      icon: "listed",
      onClick: () => {
        navigate("indicator-packages");
      },
    },
    {
      title: "Quality Control / Assurance",
      icon: "premium-quality",
      onClick: () => {
        navigate("/quality-control");
      },
    },
    {
      title: "Quality Improvement",
      icon: "improve",
      onClick: () => {
        navigate("/quality-improvement");
      },
    },
    {
      title: "Data Entry",
      icon: "laptop",
      onClick: () => {
        navigate("/data-entry");
      },
    },
    {
      title: "News",
      icon: "global-network",
      onClick: () => {
        console.log("Quality improvement");
      },
    },
    {
      title: "Report",
      icon: "business-report",
      onClick: () => {
        console.log("Quality improvement");
      },
    },
    {
      title: "Dashboard",
      icon: "analytics",
      onClick: () => {
        console.log("Quality improvement");
      },
    },
    {
      title: "Resources",
      icon: "puzzle",
      onClick: () => {
        console.log("Quality improvement");
      },
    },
    {
      title: "User Management",
      icon: "check",
      onClick: () => {
        navigate("/user-management");
      },
    },
    {
      title: "Role Management",
      icon: "role",
      onClick: () => {
        navigate("/role-management");
      },
    },
  ];
  
  let filteredMenuItems = MenuItems;

  if (user.user?.role.code !== "FACAD" && user.user?.role.code !== "MOHAD") {
    filteredMenuItems = filteredMenuItems.filter(
      (menu) => menu.title !== "User Management"
    );
  }

  if (
    user.user?.approval_requests[0]?.status === "Pending" ||
    user.user?.approval_requests[0]?.status === "Rejected"
  ) {
    filteredMenuItems = filteredMenuItems.filter(
      (menu) =>
        menu.title !== "User Management" && menu.title !== "Role Management"
    );
  } else if (user.user?.role.code !== "MOHAD") {
    filteredMenuItems = filteredMenuItems.filter(
      (menu) => menu.title !== "Role Management"
    );
  }
  console.log("Filtered Menu Items:", filteredMenuItems);
  return filteredMenuItems;
};
export default useMenuItems;
